import React from 'react'
import { UploadSustainabilityPreAssessmentFormAdminStyle } from './styled'
import {
  Button,
  Image,
  InputUpload,
  Section,
  InputTextarea,
} from '../../components'
import { ICONS } from '../../themes'

import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class UploadSustainabilityPreAssessmentFormAdminContainer extends React.Component {
  render() {
    return (
      <UploadSustainabilityPreAssessmentFormAdminStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                id="page_icon_sustainability_pre_assessment_management"
                src={ICONS['icon-risk-score-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section
                id="page_title_sustainability_pre_assessment_management"
                className="title"
              >
                {STRING.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT}
              </Section>

              <Section
                id="page_breadcrumb_sustainability_pre_assessment_management"
                className="breadcrumbs"
              >
                <Button
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  onClick={() => {
                    redirect(
                      ROUTE_PATH.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT.LINK
                    )
                  }}
                  className="breadcrumb"
                >
                  <span>{STRING.SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>Upload Sustainability Pre-Assessment</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                {STRING.UPLOAD_SUSTAINABILITY_PRE_ASSESSMENT_MANAGEMENT}
              </Section>

              <Section className="form-group is-error">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputUpload id="upload" />

                    <Button className="theme-blue">Upload</Button>
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>

              <a className="file-download-link" href="#">
                Download Sustainability Pre-Assessment Template
              </a>

              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <div className="upload-log-outter-wrapper">
                      <div className="upload-log-wrapper">
                        <span className="error">
                          Row 12 of TaxID is in the wrong format
                        </span>
                        <br />
                        <span className="success">
                          Row 12 of TaxID is in the wrong format
                        </span>
                        <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                      </div>
                    </div>
                  </Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button className="theme-border-gray">Cancel</Button>
            </Section>
          </Section>
        </Section>
      </UploadSustainabilityPreAssessmentFormAdminStyle>
    )
  }
}
